module.exports = __webpack_public_path__ + "img/iconProduceGate.6fb8a9b6.svg";